import { FacultyVM } from 'src/models/faculty.model';
import { baseApi } from './baseApi.service';
import { ENDPOINT } from '../config/apiTags';
import { FacultyIM } from '@tto/shared-models';

const facultyApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllFaculties: builder.query<FacultyVM[], void>({
      query: () => ({
        url: `${ENDPOINT.FACULTY}`,
        method: 'GET',
      }),
      providesTags: (result) =>
        result
          ? [
              // Tag the whole list
              { type: 'Faculty', id: 'LIST' },
              // Tag each faculty individually
              ...result.map(({ id }) => ({ type: 'Faculty' as const, id })),
            ]
          : [{ type: 'Faculty', id: 'LIST' }],
    }),
    createFaculty: builder.mutation<FacultyVM, FacultyIM>({
      query: (faculty) => ({
        url: `${ENDPOINT.FACULTY}`,
        method: 'POST',
        body: faculty,
      }),
      invalidatesTags: (result) =>
        result
          ? [
              { type: 'Faculty', id: 'LIST' },
              { type: 'Contact', id: 'LIST' },
            ]
          : [],
    }),
    updateFaculty: builder.mutation<string, { id: string; name: string; contactId: string }>({
      query: ({ id, name, contactId }) => ({
        url: `${ENDPOINT.FACULTY}/${id}`,
        method: 'PATCH',
        body: { name, contactId },
      }),
    }),
  }),
});

export const { useGetAllFacultiesQuery, useUpdateFacultyMutation, useCreateFacultyMutation } = facultyApi;
